import { render, staticRenderFns } from "./SvgIcon.vue?vue&type=template&id=1d266d88&scoped=true"
import script from "./SvgIcon.vue?vue&type=script&lang=js"
export * from "./SvgIcon.vue?vue&type=script&lang=js"
import style0 from "./SvgIcon.vue?vue&type=style&index=0&id=1d266d88&prod&lang=scss&scoped=true"
import style1 from "./SvgIcon.vue?vue&type=style&index=1&id=1d266d88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d266d88",
  null
  
)

export default component.exports